import React from 'react';
import { Grid2, Paper, Typography, Box, Stack } from '@mui/material';
import ProgramGrowthChart from '../../Components/LineCharts/ProgramGrowthChart';
import CycleGrowthBar from '../../Components/BarCharts/CycleGrowthBar';
import StudentAssessmentPivotTable from '../../Components/Table/StudentsAssessmentPivotTable';
import AssessmentProgression from '../../Components/FunnelCharts/AssessmentProgression';
import { useSelector } from 'react-redux';
import Gate from '../Gate';
import { fallback } from '../AdminHomeHelper';
import { ROOT } from '../../Static/static';


const ImpactAnalytics = ({ 
  studentVScore,
  assessmentCompletion,
  cycleGrowthDelim,
  cycleGrowth
  }) => {

    const perms = useSelector((state) => state.role.permissions);
    const sysRole = useSelector((state) => state.role.role);
    const canAssessment  = perms.includes("view:analytics:assessment");
    const canProgram  = perms.includes("view:analytics:program");
    return (
      <Stack spacing={3}>

        <Grid2 container spacing={2}>
          {/* Growth Comparison */}
          <Grid2 size={{ xs: 12, md: 12 }} >
            <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
              <Gate allow={sysRole === ROOT || canAssessment} fallback={fallback("view:analytics:assessment")}>
                <StudentAssessmentPivotTable data={studentVScore} />
              </Gate>
            </Paper>
          </Grid2>
          
          <Grid2 size={{ xs: 12, md: 5 }}>
          <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
              <Gate allow={sysRole === ROOT || canAssessment} fallback={fallback("view:analytics:assessment")}>
              <AssessmentProgression data={assessmentCompletion} />
              </Gate>
            </Paper>
          </Grid2>
  
          {/* Correlation & Sentiment */}
          <Grid2 size={{ xs: 12, md: 7 }}>
          <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
            <Box>
              <Gate allow={sysRole === ROOT || canProgram} fallback={fallback("view:analytics:program")}>
              <ProgramGrowthChart data={cycleGrowthDelim} />
              </Gate>
            </Box>
              
            <Box>
              <Gate allow={sysRole === ROOT || canAssessment} fallback={fallback("view:analytics:assessment")}>
                <CycleGrowthBar data={cycleGrowth} />
              </Gate>
            </Box>
            </Paper>
          </Grid2>
        </Grid2>
      </Stack>
    );
  };
  
export default ImpactAnalytics;